import dayjs from "dayjs";

import type { VehicleReservation } from "@/types/vehicleReservation";

const now = dayjs();
const year = now.year();
const month = now.month(); // 0-based

const fmt = (m: number, d: number) =>
  dayjs(new Date(year, m, d)).format("YYYY-MM-DD");

export const vehicleDummyData: VehicleReservation[] = [
  {
    id: 1,
    applicantName: "김철수",
    applicantPhone: "010-1234-5678",
    communityName: "소망공동체",
    reservationDate: fmt(month, 5),
    drivingTime: "09:00 ~ 18:00",
    purpose: "공동체 수련회 이동",
    destination: "용인 수련원",
    driverName: "이영희",
    driverPhone: "010-9876-5432",
    status: "approved",
    createdAt: fmt(month, 1),
  },
  {
    id: 2,
    applicantName: "이영수",
    applicantPhone: "010-1111-2222",
    communityName: "믿음공동체",
    reservationDate: fmt(month, 12),
    drivingTime: "08:00 ~ 20:00",
    purpose: "공동체 MT 이동",
    destination: "가평 MT 장소",
    driverName: "김민수",
    driverPhone: "010-3333-4444",
    status: "pending",
    createdAt: fmt(month, 8),
  },
  {
    id: 3,
    applicantName: "박지영",
    applicantPhone: "010-5555-6666",
    communityName: "사랑공동체",
    reservationDate: fmt(month, 20),
    drivingTime: "10:00 ~ 17:00",
    purpose: "봉사활동 이동",
    destination: "안성 봉사센터",
    driverName: "최동현",
    driverPhone: "010-7777-8888",
    status: "approved",
    createdAt: fmt(month, 15),
  },
  {
    id: 4,
    applicantName: "정민호",
    applicantPhone: "010-2222-3333",
    communityName: "은혜공동체",
    reservationDate: fmt(month, 25),
    drivingTime: "07:00 ~ 21:00",
    purpose: "선교 행사 이동",
    destination: "서울 선교센터",
    driverName: "정민호",
    driverPhone: "010-2222-3333",
    status: "rejected",
    rejectReason: "해당 날짜 차량 정비 예정",
    createdAt: fmt(month, 20),
  },
  {
    id: 5,
    applicantName: "한소연",
    applicantPhone: "010-4444-5555",
    communityName: "평강공동체",
    reservationDate: fmt(month + 1, 3),
    drivingTime: "09:00 ~ 15:00",
    purpose: "리더십 세미나 참석",
    destination: "수원 세미나홀",
    driverName: "오준혁",
    driverPhone: "010-6666-7777",
    status: "pending",
    createdAt: fmt(month, 25),
  },
  {
    id: 6,
    applicantName: "조민수",
    applicantPhone: "010-8888-9999",
    communityName: "소망공동체",
    reservationDate: fmt(month + 1, 10),
    drivingTime: "08:00 ~ 18:00",
    purpose: "교회학교 야외예배",
    destination: "천안 캠프장",
    driverName: "조민수",
    driverPhone: "010-8888-9999",
    status: "approved",
    createdAt: fmt(month + 1, 1),
  },
  {
    id: 7,
    applicantName: "김삼선",
    applicantPhone: "010-1212-3434",
    communityName: "믿음공동체",
    reservationDate: fmt(month + 1, 18),
    drivingTime: "10:00 ~ 16:00",
    purpose: "양로원 봉사",
    destination: "평택 양로원",
    driverName: "이대호",
    driverPhone: "010-5656-7878",
    status: "pending",
    createdAt: fmt(month + 1, 10),
  },
];
